<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        应急任务管理
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            v-if="operationSuper.导出"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="添加"
            icon="e6-icon-add_line"
            @click="$router.push('emergencyManageTaskManageDetails')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->

    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.dateRange">
            <el-date-picker
              v-model="slotForms.forms.dateRange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.taskId">
            <el-input
              v-model="slotForms.forms.taskId"
              placeholder="任务ID"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.comparyName">
            <el-input
              v-model="slotForms.forms.comparyName"
              placeholder="企业名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <e6Select
              :dataList="vehicleTreeList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              multiple
              ref="vehicleTreeSelect"
              placeholder="车牌号"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.status">
            <el-select v-model="slotForms.forms.status" placeholder="当前状态">
              <el-option :value="1" label="待接受"></el-option>
              <el-option :value="2" label="待运输"></el-option>
              <el-option :value="3" label="运输中"></el-option>
              <el-option :value="4" label="已结束"></el-option>
              <el-option :value="5" label="被修改"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->

    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="55"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          prop="taskId"
          header-align="center"
          label="任务ID"
          min-width="130"
          fixed="left"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column label="发货信息" header-align="center">
          <el-table-column
            prop="sendArea"
            align="center"
            label="发货区域"
            min-width="140"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sendTime"
            align="center"
            label="起运时间"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sendLinkMan"
            align="center"
            label="联系人"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="sendPhone"
            align="center"
            label="联系电话"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="收货信息" header-align="center">
          <el-table-column
            prop="receiveArea"
            align="center"
            label="收货区域"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="receiveTime"
            align="center"
            label="起运时间"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="receiveLinkMan"
            align="center"
            label="联系人"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="receivePhone"
            align="center"
            label="联系电话"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="货物信息" header-align="center">
          <el-table-column
            prop="humTemRequire"
            align="center"
            label="货物信息（温度要求、湿度要求）"
            min-width="250"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="num"
            align="center"
            label="总数量"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="weight"
            align="center"
            label="总重量（吨）"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="volume"
            align="center"
            label="总体积（㎡）"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="remake"
            align="center"
            label="备注"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="运输车辆信息" header-align="center">
          <el-table-column
            prop="plateNumber"
            align="center"
            label="车牌号"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="company"
            align="center"
            label="所属公司"
            min-width="150"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="driver"
            align="center"
            label="司机"
            min-width="80"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="telephone"
            align="center"
            label="联系电话"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="trafficNum"
            align="center"
            label="通行证"
            min-width="130"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>

        <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
          min-width="130"
          fixed="right"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="status"
          align="center"
          label="状态"
          min-width="130"
          fixed="right"
          show-overflow-tooltip
          class-name="row-state"
        >
          <template slot-scope="{ row }">
            <span :class="['state', 'state_' + row.status]">{{
              nowStatus(row.status)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="操作"
          min-width="130"
          fixed="right"
          class-name="row-operate"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span
              class="operate"
              v-if="row.status === 1 || row.status === 2"
              @click="$router.push('emergencyManageTaskManageDetails')"
              >修改</span
            >
            <span
              class="operate"
              @click="handleDelete()"
              v-if="row.status === 1 || row.status === 2"
              >删除</span
            >
            <span
              class="operate"
              v-if="row.status === 5"
              @click="
                $router.push({
                  path: '/emergencyManageTaskManageDetails',
                  query: {
                    detail: true
                  }
                })
              "
              >审核</span
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->

    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
// Api
// import { CollectFetchFindByPage } from "@/api/alarm/comparyAlarm";

// Mixins
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";

// Private Methods
import { mergeFormExtend } from "_private/utils/merge";

// Js
import { datePickerOptionsNotContainToday } from "@/utils/dateUtil.js";

// Plugs
import moment from "moment";

// Json
let res = require("./data");

// Global variable
const SEND_PEOPLE_NAME = ["张三", "李四", "王五", "牛儿", "马冬梅"];
const RECEIVE_PEOPLE_NAME = ["楚雨荨", "端木磊", "慕容复", "乔峰", "欧阳锋"];
export default {
  mixins: [resizeListener, operationManage],

  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      vehicleTreeList: [], // 车辆下拉树
      formExtend: {
        forms: {
          dateRange: [],
          taskId: "", // 任务ID
          comparyName: "",
          status: "", // 当前状态
          sortColumnName: "", //排序列名code
          sortType: 0 //排序方式 1-正序 2-倒序
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      loading: "false",
      datePickerOptions: datePickerOptionsNotContainToday,
      //导出URL
      exportUrl: "/report/alarmSummary/exportComparyAlarmSummary?"
    };
  },

  created() {
    // 条件查询时间范围恢复默认值-今天
    this.formExtend.forms.dateRange = [
      moment()
        .startOf("day")
        .toDate(),
      moment()
        .endOf("day")
        .toDate()
    ];
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
  },

  methods: {
    // 检验时间40天 && 时间不能为空
    validataTime() {
      let start = moment(this.formExtend.forms.dateRange[0]);
      let end = moment(this.formExtend.forms.dateRange[1]);
      //判断时间间隔不能大于40天
      if (end.diff(start, "days") > 39) {
        this.$message.warning("开始时间与结束时间间隔不能大于40天！");
        return false;
      } else {
        return true;
      }
    },

    // 获取表格数据
    FetchFindByPage(response) {
      if (!response.dateRange) {
        this.$message.warning("开始时间与结束时间不能为空！");
        return false;
      }
      if (this.validataTime()) {
        this.loading = true;
        // response.beginTime = moment(response.dateRange[0])
        //   .startOf("day")
        //   .valueOf();
        // response.endTime = moment(response.dateRange[1])
        //   .endOf("day")
        //   .valueOf();
        // delete response.dateRange;
        // CollectFetchFindByPage(response)
        //   .then(response => {
        //     if (
        //       response.result &&
        //       response.result.data &&
        //       Array.isArray(response.result.data)
        //     ) {
        //       this.tableData = response.result.data;
        //       this.total = response.result.totalRecords;
        //     }
        //     this.loading = false;
        //   })
        //   .catch(error => {
        //     this.loading = false;
        //     console.log(error);
        //   });

        let tableData = {};
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result.data)) {
            tableData = res.result.data[0];
          }
        }
        for (let i = 0; i < 55; i++) {
          this.tableData[i] = {
            sendLinkMan: SEND_PEOPLE_NAME[Math.floor(Math.random() * 5)],
            receiveLinkMan: RECEIVE_PEOPLE_NAME[Math.floor(Math.random() * 5)],
            status: Math.floor(Math.random() * 5 + 1),
            ...tableData
          };
        }
        this.total = 55;
        this.loading = false;
      }
    },

    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },

    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },

    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },

    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    //导出
    handleExportClick() {
      let param = "";
      if (
        this.formExtend.forms.dateRange !== null &&
        this.formExtend.forms.dateRange !== ""
      ) {
        param +=
          "&beginTime=" +
          moment(this.formExtend.forms.dateRange[0])
            .startOf("day")
            .valueOf();
        param +=
          "&endTime=" +
          moment(this.formExtend.forms.dateRange[1])
            .endOf("day")
            .valueOf();
        param += "&comparyName=" + this.formExtend.forms.comparyName;
        param += "&sortColumnName=" + this.formExtend.forms.sortColumnName;
        param += "&sortType=" + this.formExtend.forms.sortType;
        document.location.href = this.exportUrl + param;
      } else {
        this.$message({
          showClose: true,
          message: "开始时间与结束时间不能为空！",
          type: "warning"
        });
      }
    },

    // 删除
    handleDelete() {
      this.$confirm("是否删除此任务", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 当前状态
    nowStatus(code) {
      let res = "";
      switch (code) {
        case 1:
          res = "待接受";
          break;
        case 2:
          res = "待运输";
          break;
        case 3:
          res = "运输中";
          break;
        case 4:
          res = "已结束";
          break;
        case 5:
          res = "被修改";
          break;
        default:
          res = "";
      }
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;

  .row-state {
    .state {
      display: inline-block;
      padding: 0px 10px;
      font-size: 12px;
      color: #fff;
      line-height: 20px;
      border-radius: 20px;

      $class-colors-list: #9255de, #66ccff, #67c23a, #91a5c4, #e6a23c;
      @for $i from 1 through 5 {
        &_#{$i} {
          background-color: nth($class-colors-list, $i);
        }
      }
    }
  }

  .row-operate {
    .operate {
      margin: 0 10px;
      color: #0099ff;
      cursor: pointer;
    }
  }
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
</style>
